import api from './api'
import auth from './auth'
import io from './io'
import ui from './ui'
import dict from './dict'

export default [
    api,
    auth,
    io,
    ui,
    dict
]